import { AsyncStore } from "~/store/async-store"
import { initial } from "~/store/async-store.utils"
import type { Attachment } from "./attachment.model"

type Err = string
type Ok = {
  attachments: Attachment[]
}

export class FilesStore extends AsyncStore<Err, Ok> {
  constructor() {
    super("FilesStore", initial)
  }
}
